import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
// CSS import
import classes from './TVShortsCard.module.css';

import TVCardVideo from './TVCardVideo/TVCardVideo';
import TVCardImage from './TVCardImage/TVCardImage';
import TVCardMediaCarousel from './TVCardMedia/TVCardMediaCarousel';

// Redux dispatch to dispatch user credentials
import { useSelector } from 'react-redux';
import { Avatar } from '@mui/material';
import TVCardDescription from './TVCardDescription/TVCardDescription';

function TVShortsCard({ postData, index, visiblePostIndex, setVisiblePostIndex = () => null, handleClick=true }) {
  // Destructuring postData props
  const { id, project_title, content_type, creator } = postData;
  const navigate = useNavigate();
  const { userProfileData } = useSelector((state) => state.userProfileSlice);

  const allowedVideoExtensions = ['.mkv', '.mp4', '.mov'];
  const { image_field: { images }, aspect_ratio } = postData;


  const displayOutput = (data, characters) => {
    if (data.length <= characters) {
      return data;
    }
    return data.substring(0, characters) + '...';
  };
  const creatorNameClickHandler = (profileId) => {
    if (profileId === userProfileData.id) {
      navigate(`/userprofile`);
    } else {
      navigate(`/accounts/${profileId}/profile/`);
    }
  };

  return (
    <div
      onClick={() => handleClick && navigate(`/short/${postData.id}`)}
      className={classes.shortContainer}
    >
      {/* {JSON.stringify(images)} */}
      <div className={classes.imgContainer}>
        {
          allowedVideoExtensions.some(extension => images[0].includes(extension)) ?
            <TVCardVideo isShorts src={images[0]} aspectRatio={aspect_ratio} isVisible={index === visiblePostIndex} />
            :
            <TVCardImage postData={postData} isShortCard isShorts />
        }
      </div>
      <div className={classes.textContainer}>

        <div className={classes.infoContainer}>
          <div className={classes.creatorInfo}>
            <Avatar
              src={creator.profile_pic}
              className={classes.creatorPic}
              onClick={() => creatorNameClickHandler(creator.id)}
              alt="Profile_pic"
            />
            <h2
              className={classes.creatorName}
              onClick={() => creatorNameClickHandler(creator.id)}
            >
              {creator.name}
            </h2>
          </div>

          <span className={classes.shortDescription} >{project_title}</span>
        </div>
      </div>
    </div>
  );
}

export default TVShortsCard;
